const sharetribeSdk = require('sharetribe-flex-sdk');

const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });
  

 export const getMasterCalendarPlan = () => {
    return sdk.ownListings.query({}).then(res => {
        const listingsArray = res.data.data;
       const masterCalProperty =  listingsArray.find(listing => {
          return listing.attributes.publicData.listingType === "masterListing"
        });
        return masterCalProperty
     }).catch(error => {
         console.log(error)
     });

  }
 